import React, { useState } from "react";
import { createRoot } from "react-dom/client";

const menuDom = document.querySelector("#menu-button");
const root = createRoot(menuDom);

const MenuButton = () => {
    const [isOpen, setIsOpen] = useState(false);
    const handleButtonClick = () => {
        setIsOpen(!isOpen);
        document.querySelector("body").classList.toggle("fixedBody");
        document.querySelector("#header__site").classList.toggle("is-active");
        document.querySelector("#header__nav").classList.toggle("is-active");
    };
    return (
        <React.Fragment>
            <button
                className={isOpen ? "is-active" : ""}
                onClick={handleButtonClick}
            >
                <div className="hamburger__bars">
                    <span className="bar"></span>
                </div>
            </button>
        </React.Fragment>
    );
};

root.render(<MenuButton />);
